import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AlertDialogComponent } from './alert/alert.component';
import { DialogContainerComponent } from './dialog-container.component';
import { DialogBackComponent } from './dialog-back.compnent';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './confirm/confirm.component';
import { DialogFooterHelperComponent } from './helpers/d-footer.component';
import { DialogBodyHelperComponent } from './helpers/d-body.component';
import { DialogHeaderHelperComponent } from './helpers/d-header.component';
import { InputDialogComponent } from './input/input.component';
import { FormsModule } from '@angular/forms';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { InputDialogValidationsService } from './input/input-dialog-validations.service';
import { AlertWithOptionDialogComponent } from './alert-with-options/alert-with-options.component';
import { FileDeleteAlertComponent } from './file-delete-alert/file-delete-alert.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormatStringPipe } from './pipes/format-string.pipe';
import { UploadErrorsDialogComponent } from './upload-errors/upload-errors.component';
import { AlertDublicateFileComponent } from './alert-dublicate-file/alert-dublicate-file.component';

const components = [
  DialogContainerComponent, DialogBackComponent, AlertDialogComponent, ConfirmDialogComponent, InputDialogComponent,
  DialogFooterHelperComponent, DialogHeaderHelperComponent, DialogBodyHelperComponent, AlertWithOptionDialogComponent,
  FileDeleteAlertComponent, UploadErrorsDialogComponent, AlertDublicateFileComponent
];

@NgModule({
  imports: [CommonModule, FormsModule, CommonDirectivesModule, TranslateModule.forChild()],
  declarations: [...components, FormatStringPipe],
  providers: [InputDialogValidationsService],
  entryComponents: [DialogContainerComponent, DialogBackComponent, AlertDialogComponent, ConfirmDialogComponent, InputDialogComponent,
    DialogFooterHelperComponent, DialogHeaderHelperComponent, DialogBodyHelperComponent, AlertWithOptionDialogComponent, FileDeleteAlertComponent,
    UploadErrorsDialogComponent, AlertDublicateFileComponent],
  exports: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogModule {
}


